import { api } from "../api";

/**
 * findAllSecretariesByCustomerIdListResponse - Function that finds on database all secretaries by customer id as select list response  
 * /secretaries/list/{customerId}   
 * method GET 
 * @async-function
 */
const findAllSecretariesByCustomerIdListResponse = async (token: string, customerId: number) => {
    const response = await api.get(
        `/secretaries/list/${customerId}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        },
    }
    );
    return response;
};

export default findAllSecretariesByCustomerIdListResponse;